import type { DashboardStats } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getDashboardStats = async (): Promise<
  ServiceResponse<DashboardStats>
> => {
  const response =
    await privateAPI.get<ServiceResponse<DashboardStats>>("/dashboard/stats");
  return response.data;
};
